/** Guarantees an integer */
export default function guardNumber(value, fallback, preRound) {
    if (preRound === void 0) { preRound = function (v) { return v; }; }
    var parsed = parseFloat(value !== null && value !== void 0 ? value : '');
    if (Number.isNaN(parsed)) {
        return fallback;
    }
    return Math.round(preRound(parsed));
}
export function guardNumberPositive(value) {
    return guardNumber(value, 0, function (v) { return Math.max(0, v); });
}
